export const SET_APP_VERSION = "SET_APP_VERSION";
